<template>
  <div style="margin:auto;width:70%;">
    <button
        class="btn btn-block btn-dark" style="margin:3px;color:white; background-color: #dc1818"
        @click="goBackToBattlePanel()">
      Battle Menu
    </button>
  </div>

  <div class="container">
    <div style="min-height: 5%"/>

    <div class="center">
      <div class="leaderboard-row__header">
        <span class="text" style="flex: 1">Position</span>
        <span style="flex: 2" class="text">Name</span>
        <span style="flex: 1" class="text">MMR</span>
      </div>
      <div
          v-for="player in ranking"
          v-bind:key="player.username"
          class="leaderboard-row"
          v-bind:class="{
          gold: player.position === 1,
          silver: player.position === 2,
          bronze: player.position === 3,
          'even-light':
            ![1, 2, 3].includes(player.position) &&
            player.position % 2 === 0 &&
            theme_mode === 'light',
          'even-dark':
            ![1, 2, 3].includes(player.position) &&
            player.position % 2 === 0 &&
            theme_mode === 'dark',
          'odd-light':
            ![1, 2, 3].includes(player.position) &&
            player.position % 2 !== 0 &&
            theme_mode === 'light',
          'odd-dark':
            ![1, 2, 3].includes(player.position) &&
            player.position + (1 % 2) !== 0 &&
            theme_mode === 'dark',
          player: player.username === currentPlayer.username,
        }"
      >
        <span style="flex: 1" class="text">{{ player.position }}</span>
        <span style="flex: 2" class="text">{{ player.username }}</span>
        <span style="flex: 1" class="text">{{ player.mmr }}</span>
      </div>
    </div>
    <div style="min-height: 5%"/>
  </div>
</template>

<script>
import {onMounted, onUnmounted, ref} from "vue";
import {unblockButton} from "../../components/ButtonControl/ButtonControl";
import Cache from "../../cache";
import {currentView, theme_mode} from "../../utils/globals";

import {
  startLoadingProcess,
  stopLoadingProcess,
} from "../../components/LoadingOverlay/loadingOverlayControl";
import {useQueryClient} from "vue-query";
import {wait} from "../../utils/utilities";
import BattleSlotPanel from "../Battle/BattleSlotPanel";

export default {
  setup() {
    const queryClient = useQueryClient();

    const ranking = ref([]);
    const currentPlayer = ref({});

    const addPosition = (player, index) => {
      return {
        ...player,
        position: index + 1,
      };
    };

    const isPlayerInRanking = (player, ranking) => {
      return ranking.some((p) => player.username === p.username);
    };

    const addPlayerInRankingIfNedded = () => {
      if (!isPlayerInRanking(currentPlayer.value, ranking.value)) {
        ranking.value.push({
          username: currentPlayer.value.username,
          position: currentPlayer.value.rank,
          mmr: currentPlayer.value.mmr,
        });
      }
    };

    const refreshView = async () => {
      startLoadingProcess();

      const data = Cache.Leaderboard.getLeaderboard(queryClient);

      // Wait at least 250 ms, cached or not. This gives a better experience
      // than instantly loading the page.
      await Promise.all([wait(250), data]).then(([, response]) => {
        currentPlayer.value = response.currentPlayer;

        ranking.value = response.top100.map(addPosition);
        addPlayerInRankingIfNedded(currentPlayer.value, ranking.value);
      });

      stopLoadingProcess();
    };

    onMounted(async () => {
      console.debug("Mounted...");
      await refreshView();
      unblockButton();
    });

    onUnmounted(() => {
      console.debug("Unmounted...");
    });

    const goBackToBattlePanel = () => {
      currentView.value = BattleSlotPanel;
    };

    return {
      ranking,
      currentPlayer,
      theme_mode,
      refreshView,
      goBackToBattlePanel
    };
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.center {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.leaderboard-row {
  display: flex;
  flex: 1;
  width: 80%;
  justify-content: space-between;
  padding: 5px;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;

  &__header {
    @extend .leaderboard-row;
    background: #ff444b;
    border-radius: 8px 8px 0 0;
    border-top: 1px solid black;
    color: white;
  }
}

.text {
  text-align: center;
}

.gold {
  background: goldenrod;
  color: white;
  text-shadow: 1px 1px black;
}

.silver {
  background: silver;
  color: white;
  text-shadow: 1px 1px black;
}

.bronze {
  background: #cd7f32;
  color: white;
  text-shadow: 1px 1px black;
}

.odd {
  background: #707070;

  &-light {
    @extend .odd;
    color: white;
    text-shadow: 1px 1px black;
  }

  &-dark {
    @extend .odd;
    color: white;
    text-shadow: 1px 1px black;
  }
}

.even {
  &-light {
    background: white;
    color: black;
  }

  &-dark {
    background: #494949;
    color: white;
    text-shadow: 1px 1px black;
  }
}

.player {
  background: #ff444b;
}
</style>
